<template>
  <el-table
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    :data="arealist"
    :max-height="pane_height"
    style="width: 100%">
    <el-table-column
      prop="town"
      label="エリア名">
      <template #default="scope">
        {{scope.row.gst_name}}{{ scope.row.town}}
      </template>
    </el-table-column>
    <el-table-column
      prop="order_qty"
      label="配布部数"
      class-name="right"
      width="100">
    </el-table-column>
    <el-table-column
      label="反響率"
      class-name="right"
      width="80">
      <template #default="scope">
        {{ ((scope.row.resval + scope.row.get_order_qty) / scope.row.order_qty * 100).toFixed(3) }}%
      </template>
    </el-table-column>
    <el-table-column
      label="問合数"
      width="150">
      <template #default="scope">
        <el-input-number size="mini" placeholder="0" :min="0" :step="1" v-model="scope.row.resval"></el-input-number>
      </template>
    </el-table-column>
    <el-table-column
      label="受注数"
      width="150">
      <template #default="scope">
        <el-input-number size="mini" placeholder="0" :min="0" :step="1" v-model="scope.row.get_order_qty"></el-input-number>
      </template>
    </el-table-column>
    <el-table-column
      label="受注金額"
      width="150">
      <template #default="scope">
        <el-input-number size="mini" placeholder="0" :min="0" :step="1000" v-model="scope.row.get_order_mnt"></el-input-number>
      </template>
    </el-table-column>
    <el-table-column
      label="反響コメント"
      width="200">
      <template #default="scope">
        <el-input size="mini" placeholder="Please Input" v-model="scope.row.rescom"></el-input>
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: ['arealist', 'loading'],
  setup() {
    const pane_height = document.body.clientHeight - 390
    return {
      pane_height
    }
  }
})
</script>